(() => {
  const publish = (eventName, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
    window.Shopify?.analytics?.publish?.(`the_limely:${eventName}`, payload);
  };

  document.addEventListener('click', (event) => {
    const route = event.target.closest('[data-contact-route]');
    if (route) {
      publish('contact_route_click', {
        route: route.dataset.contactRoute || '',
        destination_host: new URL(route.href, window.location.href).host
      });
      return;
    }

    const supportLink = event.target.closest('[data-contact-support-link]');
    if (supportLink) {
      publish('contact_support_link_click', {
        support_type: supportLink.dataset.contactSupportLink || ''
      });
    }
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-limely-contact] form')) return;
    publish('contact_form_submit_attempt');
  });

  const result = document.querySelector('[data-limely-contact] [data-contact-result]');
  if (result) {
    publish('contact_form_result', { status: result.dataset.contactResult || '' });
    result.focus({ preventScroll: true });
  }
})();
